import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { HYDRATE } from "next-redux-wrapper";

const developmentAdapter = createEntityAdapter({
    selectId: (development) => development.id,
});

export const developmentSlice = createSlice({
    name: "development",
    initialState: developmentAdapter.getInitialState(),
    reducers: {
        add: developmentAdapter.addOne,
        update: developmentAdapter.upsertOne,
        remove: developmentAdapter.removeOne,
        empty: developmentAdapter.removeAll,
    },
    extraReducers: (builder) => {
        builder.addCase(HYDRATE, (state, action) => {
            return {
                ...state,
                ...action.payload.subject,
            };
        });
    },
});

export const { actions } = developmentSlice;

export const selectors = developmentAdapter.getSelectors((state) => state.development);
